export function replaceAttrSpaceWithHyphen(attribute: string) {
  return attribute?.includes(` `)
    ? attribute?.toLowerCase().replace(/ /g, `-`)
    : attribute?.toLowerCase();
}
